import Vue from "vue";

/**
 * Thin wrapper around vue-toast-notification so non-component modules
 * (e.g. axios interceptors) can show toasts. The plugin registers the
 * toast API on Vue.prototype.$toast in main.js at app bootstrap.
 */
export default {
    open(options) {
        const toast = Vue.prototype.$toast;
        if (toast && typeof toast.open === "function") {
            toast.open(options);
        }
    }
};
